import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import handleOpenWhatsApp from 'services/whatsappService';
import { enProduccionConMemForegroundOnPage } from '../enProduccionConMemReadableText';
import { EN_PRODUCCION_CON_MEM_LOGO_SRC, EN_PRODUCCION_CON_MEM_TNO_SHOW_URL } from '../brandAssets';

const AreYouReady = () => {
  const theme = useTheme();
  const headingColor = enProduccionConMemForegroundOnPage(theme);
  const accent = theme.palette.secondary.main;
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box>
      <Box
        component={Typography}
        sx={{
          fontWeight: 700,
          fontFamily: 'Georgia, "Times New Roman", serif',
          color: headingColor,
        }}
        variant="h2"
        gutterBottom
        align="center"
        marginBottom="2rem"
      >
        Hagamos visible su marca en la conversación publicitaria.
      </Box>
      <Box
        component={Typography}
        sx={{ fontWeight: 600 }}
        variant="h4"
        gutterBottom
        align="center"
        marginBottom="2rem"
        color="textSecondary"
      >
        Reserve su espacio y alinee su mensaje con María Eugenia Moreno, el streaming TNO y el ecosistema digital TNO
        Network.
      </Box>

      <Grid container spacing={4}>
        <Grid item container alignItems="center" xs={12} md={6}>
          <Box data-aos={isMd ? 'fade-right' : 'fade-up'}>
            <Box marginBottom={2}>
              <Typography variant="h5" color="textPrimary" sx={{ fontWeight: 700 }}>
                Asocie su marca a cultura publicitaria, negocio y alcance multiplataforma — presencia en vivo, en
                biblioteca On-Demand y refuerzo en redes.
              </Typography>
            </Box>
            <Box marginBottom={2}>
              <Typography variant="body2" color="textSecondary" component="div">
                <strong>Teléfono:</strong>{' '}
                <Link
                  href="tel:+584141355751"
                  sx={{ color: headingColor, '&:hover': { color: accent } }}
                >
                  (+58) 414-1355751
                </Link>
                <br />
                <strong>Correo comercial:</strong>{' '}
                <Link
                  href="mailto:mercadeoyventas@tnonetwork.com"
                  sx={{ color: headingColor, '&:hover': { color: accent } }}
                >
                  mercadeoyventas@tnonetwork.com
                </Link>
                <br />
                <strong>Instagram:</strong>{' '}
                <Link
                  href="https://www.instagram.com/tnonetwork/"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ color: headingColor, '&:hover': { color: accent } }}
                >
                  @tnonetwork
                </Link>
              </Typography>
            </Box>
            <Box
              display="flex"
              flexDirection={{ xs: 'column', sm: 'row' }}
              alignItems={{ xs: 'stretched', sm: 'flex-start' }}
            >
              <Button
                component="a"
                variant="contained"
                color="primary"
                size="large"
                fullWidth={isMd ? false : true}
                onClick={handleOpenWhatsApp}
                target="_blank"
              >
                Patrocinar En Producción con MEM
              </Button>
              <Box marginTop={{ xs: 2, sm: 0 }} marginLeft={{ sm: 2 }} width={{ xs: '100%', md: 'auto' }}>
                <Button
                  component="a"
                  href={EN_PRODUCCION_CON_MEM_TNO_SHOW_URL}
                  variant="outlined"
                  color="primary"
                  size="large"
                  fullWidth={isMd ? false : true}
                >
                  Ver programa
                </Button>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box height="100%" width="100%" display="flex" justifyContent="center" alignItems="center">
            <Box
              height="100%"
              width="100%"
              maxHeight={600}
              minHeight={{ xs: 280, md: 360 }}
              display="flex"
              alignItems="center"
              justifyContent="center"
              sx={{
                border: `2px solid ${accent}`,
                borderRadius: 2,
                bgcolor: '#fff',
                py: 4,
                px: 3,
              }}
            >
              <Box
                component="img"
                src={EN_PRODUCCION_CON_MEM_LOGO_SRC}
                alt="En Producción con MEM — logo oficial"
                sx={{
                  width: '100%',
                  maxWidth: 400,
                  maxHeight: 420,
                  objectFit: 'contain',
                }}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Box marginTop={4} textAlign="center">
        <Typography variant="body2" color="textSecondary">
          © TNO Network 2026 | En Producción con MEM con María Eugenia Moreno — Creatividad con respaldo.
        </Typography>
      </Box>
    </Box>
  );
};

export default AreYouReady;
